module.exports = __webpack_public_path__ + "assets/info.554ebc24.svg";